export default __webpack_public_path__ + "static/media/Advanced Potion Making - BasedOn-02_02.fe727060.jpg";